import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_URL, PHONE_TEL, PHONE_DISPLAY } from "@/data/content";
import { Reveal } from "./anim";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer id="contact" className="relative bg-ink text-cream py-24 md:py-32" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-8xl tracking-tight leading-[0.95] max-w-4xl">
            {f.title}
          </h2>
          <p className="mt-8 font-light text-base sm:text-lg text-cream/60 max-w-xl leading-relaxed">{f.text}</p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col sm:flex-row flex-wrap gap-4">
            <a
              data-testid="footer-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-4 rounded-full bg-whatsapp text-ink px-10 py-5 text-sm tracking-[0.15em] uppercase font-medium hover:bg-cream transition-colors duration-500"
            >
              {f.cta}
              <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">→</span>
            </a>
            <a
              data-testid="footer-call"
              href={`tel:${PHONE_TEL}`}
              className="group inline-flex items-center justify-center gap-3 rounded-full border border-cream/30 text-cream px-10 py-5 text-sm tracking-[0.15em] uppercase hover:bg-cream hover:text-ink transition-colors duration-500"
            >
              {f.callCta} · {PHONE_DISPLAY}
            </a>
          </div>
        </Reveal>

        <div className="mt-24 pt-8 border-t border-cream/15 flex flex-col md:flex-row justify-between gap-6 text-xs tracking-[0.15em] uppercase text-cream/50">
          <span className="font-serif text-lg tracking-normal text-cream normal-case">
            Steve<span className="text-brand italic"> Massage</span>
          </span>
          <a href={`tel:${PHONE_TEL}`} className="hover:text-cream transition-colors">
            {f.phoneLabel} · {PHONE_DISPLAY}
          </a>
          <span>{f.location}</span>
          <span>© {new Date().getFullYear()} · {f.rights}</span>
        </div>
      </div>
    </footer>
  );
}
